module.exports = __WEBPACK_EXTERNAL_MODULE_82__;


//////////////////
// WEBPACK FOOTER
// external "gemini/lib/@waca/dashboard-common/dist/api/ContentActionsProviderAPI"
// module id = 82
// module chunks = 1